const models = [
  {
    name: "Leibrente",
    payout: "Monatliche Rente",
    residence: "Lebenslang (Grundbuch)",
    ownership: "Geht an Käufer",
    inheritance: "Nein",
    idealAge: "Ab 75 Jahren",
    href: "/leibrente",
  },
  {
    name: "Wohnrecht",
    payout: "Einmalzahlung / Zeitrente",
    residence: "Lebenslang (Grundbuch)",
    ownership: "Geht an Käufer",
    inheritance: "Nein",
    idealAge: "Ab 65 Jahren",
    href: "/wohnrecht",
  },
  {
    name: "Nießbrauch",
    payout: "Steuervorteile",
    residence: "Lebenslang + Vermietung",
    ownership: "An Erben (Schenkung)",
    inheritance: "Ja",
    idealAge: "Ab 60 Jahren",
    href: "/niessbrauch",
  },
  {
    name: "Teilverkauf",
    payout: "Sofortige Einmalzahlung",
    residence: "Lebenslang (Grundbuch)",
    ownership: "Restwert bleibt",
    inheritance: "Teilweise",
    idealAge: "Ab 65 Jahren",
    href: "/teilverkauf",
  },
  {
    name: "Rückmiete",
    payout: "Gesamter Kaufpreis",
    residence: "Mietvertrag",
    ownership: "Geht an Käufer",
    inheritance: "Nein",
    idealAge: "Ab 65 Jahren",
    href: "/rueckmiete",
  },
  {
    name: "Seniorenfinanzierung",
    payout: "Kredit (flexibel)",
    residence: "Uneingeschränkt",
    ownership: "Bleibt erhalten",
    inheritance: "Ja (nach Ablösung)",
    idealAge: "Ab 60 Jahren",
    href: "/seniorenfinanzierung",
  },
];

const ComparisonTable = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container-comfortable">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 text-center">
          Alle 6 Verrentungsmodelle im Vergleich
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto text-center mb-4">
          Eigenheimverrentung bietet 6 bewährte Wege, Kapital aus der Immobilie zu lösen und trotzdem wohnen zu bleiben. Die richtige Wahl hängt von Alter, Kapitalbedarf und Erbwunsch ab.
        </p>
        <p className="text-base text-muted-foreground max-w-2xl mx-auto text-center mb-10">
          Die folgende Tabelle zeigt die wichtigsten Unterschiede auf einen Blick – von Auszahlungsform über Wohnrecht bis zur Erbschaftsregelung.
        </p>

        {/* Desktop table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full border-collapse text-left">
            <thead>
              <tr className="border-b-2 border-primary/20">
                <th className="py-4 px-4 text-primary font-bold text-base">Modell</th>
                <th className="py-4 px-4 text-primary font-bold text-base">Auszahlung</th>
                <th className="py-4 px-4 text-primary font-bold text-base">Wohnrecht</th>
                <th className="py-4 px-4 text-primary font-bold text-base">Eigentum</th>
                <th className="py-4 px-4 text-primary font-bold text-base">Erbe möglich</th>
                <th className="py-4 px-4 text-primary font-bold text-base">Ideal ab</th>
              </tr>
            </thead>
            <tbody>
              {models.map((m) => (
                <tr key={m.name} className="border-b border-border hover:bg-muted/50 transition-colors">
                  <td className="py-3 px-4 font-semibold text-primary">
                    <a href={m.href} className="hover:text-accent transition-colors underline decoration-accent/30">
                      {m.name}
                    </a>
                  </td>
                  <td className="py-3 px-4 text-muted-foreground">{m.payout}</td>
                  <td className="py-3 px-4 text-muted-foreground">{m.residence}</td>
                  <td className="py-3 px-4 text-muted-foreground">{m.ownership}</td>
                  <td className="py-3 px-4 text-muted-foreground">{m.inheritance}</td>
                  <td className="py-3 px-4 text-muted-foreground">{m.idealAge}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4">
          {models.map((m) => (
            <a
              key={m.name}
              href={m.href}
              className="block border border-border rounded-xl p-4 bg-card hover:shadow-md transition-shadow"
            >
              <h3 className="text-lg font-bold text-primary mb-2">{m.name}</h3>
              <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
                <dt className="text-muted-foreground font-medium">Auszahlung</dt>
                <dd className="text-foreground">{m.payout}</dd>
                <dt className="text-muted-foreground font-medium">Wohnrecht</dt>
                <dd className="text-foreground">{m.residence}</dd>
                <dt className="text-muted-foreground font-medium">Eigentum</dt>
                <dd className="text-foreground">{m.ownership}</dd>
                <dt className="text-muted-foreground font-medium">Erbe</dt>
                <dd className="text-foreground">{m.inheritance}</dd>
              </dl>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
